// 'success' 'error' 'warning' 'info'
export default {
  MESSAGE_SUCCESS: 'SUCCESS',
  MESSAGE_ERROR: 'ERROR',
  MESSAGE_ERROR_LIST: 'ERROR_LIST',
  MESSAGE_WARNING: 'WARNING',
  MESSAGE_INFO: 'INFO',
  MESSAGE_CLEAR: 'CLEAR',
};
